import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ReportsRepository from "src/repository/Admin/ReportRepository";

export const getReportsList = createAsyncThunk('get_reports_list', async (params) => {
    const data = await new ReportsRepository().getReportsList(params);
    return data;
});

const slice = createSlice({
    name: "Reports",
    initialState: {
        totalRecords: 0,
        filteredRecords: 0,
        reportsList: [],
    },
    reducers: {
        setReportsList: {
            reducer: (state, action) => {
                state.reportsList = action.payload;
                return state;
            },
        },
    },
    extraReducers: {
        [getReportsList.fulfilled]: (state, action) => {
            state.reportsList = action.payload.data?.getListOfAccountAndUserReport;
            state.totalRecords = action.payload.data?.total;
            state.filteredRecords = action.payload.data?.getListOfAccountAndUserReport?.length;
        },
    },
});



export let { setReportsList } = slice.actions;

export default slice.reducer;
